module.exports = __webpack_public_path__ + "static/media/pokemon.a4f594f6.jpg";